import { Action } from 'react-fetching-library';
import { ArticleInfo, ArticleRequest } from '../../../common/types';



export const getArticleAction: any = (getArticleInput: ArticleRequest) => <Action<ArticleInfo>>({
    method: 'POST',
    endpoint: '/article/get',
    body: getArticleInput
})